import React from 'react';
import MythicCommanderBanner from 'components/Elements/Shared/MythicCommanderBanner';
import Flex from 'components/Elements/Shared/Flex';
import SearchBar from 'components/Elements/Shared/SearchBar';
import { CLASH_BASE_URL } from 'constants/network';
import { Space } from 'antd';
import Externalicon from 'components/Elements/Shared/ExternalIcon/Externalicon';
import styles from './Menu.module.css';
import UserMenu from './UserMenu';
import Navigation from './Navigation';

const Menu = () => {
  return (
    <div className={styles.menu}>
      <Flex
        direction="row"
        align="center"
        justify="space-between"
        style={{ width: '100%' }}
      >
        <Flex direction="row" align="center">
          <MythicCommanderBanner
            style={{ marginLeft: 8 }}
            showCollectionOnClick
            hideWhenSmall
          />
          <Navigation />
          <a
            className={styles.playLink}
            href={CLASH_BASE_URL}
            target="_blank"
            rel="noreferrer"
          >
            Play
            <Externalicon size={22} />
          </a>
        </Flex>
        <SearchBar
          hideLayover
          style={{ margin: '0 16px', width: '100%', maxWidth: 330 }}
        />
        <Space>
          <UserMenu />
        </Space>
      </Flex>
    </div>
  );
};

export default Menu;
